import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';
import { toast } from 'sonner';
import { Card, CardContent } from '../components/ui/card';
import { Shield, Edit2, Save, X, Plus, Trash2, ArrowUp, ArrowDown, FileDown, Calendar, Hash } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default template from PDF
const DEFAULT_PRIVACY_CONTENT = [
  { id: '1', type: 'heading', content: 'Politica Privacy' },
  { id: '2', type: 'note', content: 'Ultimo aggiornamento: 04 febbraio 2026 alle ore 10:00' },
  { id: '3', type: 'heading', content: 'Titolare del Trattamento' },
  { id: '4', type: 'paragraph', content: 'Il Titolare del trattamento dei dati personali raccolti attraverso la piattaforma e-CAA è:\n\nFederlombarda Agricoltori\n\nIl Titolare è responsabile della definizione delle finalità e delle modalità del trattamento dei dati personali degli utenti della piattaforma.\n\nPer qualsiasi domanda relativa al trattamento dei dati personali, è possibile contattare il Titolare all\'indirizzo email indicato nella sezione Contatti.' },
  { id: '5', type: 'heading', content: 'Base Giuridica' },
  { id: '6', type: 'paragraph', content: 'Il trattamento dei dati personali si fonda sulle seguenti basi giuridiche ai sensi del Regolamento (UE) 2016/679 (GDPR):' },
  { id: '7', type: 'list', content: 'Esecuzione del contratto: il trattamento è necessario per la fornitura del servizio e-CAA\nObblighi legali: il trattamento è necessario per adempiere ad obblighi di legge\nLegittimo interesse: per la sicurezza del sistema e la prevenzione di frodi' },
  { id: '8', type: 'heading', content: 'Finalità del Trattamento' },
  { id: '9', type: 'list', content: 'Gestione dell\'autenticazione e dell\'accesso al sistema\nErogazione del servizio di valutazione della maturità dei processi\nComunicazioni di servizio relative alla piattaforma\nAdempimento di obblighi normativi e regolamentari' },
  { id: '10', type: 'heading', content: 'Tipologie di Dati Raccolti' },
  { id: '11', type: 'paragraph', content: 'Nell\'ambito del servizio e-CAA, vengono raccolti e trattati i seguenti dati personali:' },
  { id: '12', type: 'paragraph', content: 'Dati di identificazione: Indirizzo email, Nome e cognome (nome visualizzato), Credenziali di accesso (password cifrata)' },
  { id: '13', type: 'paragraph', content: 'Dati dell\'organizzazione: Denominazione dell\'organizzazione, Dati del referente (nome, email, telefono), Dati delle sedi CAA associate' },
  { id: '14', type: 'paragraph', content: 'Dati di utilizzo: Risposte ai questionari di valutazione, Timestamp di accettazione privacy e termini, Log di accesso al sistema (data, ora)' },
  { id: '15', type: 'heading', content: 'Conservazione dei Dati' },
  { id: '16', type: 'paragraph', content: 'I dati personali sono conservati per il tempo strettamente necessario al raggiungimento delle finalità per cui sono stati raccolti:' },
  { id: '17', type: 'list', content: 'Dati di account: Conservati per tutta la durata del rapporto contrattuale e per i 10 anni successivi alla cessazione, per obblighi di legge\nQuestionari e valutazioni: Conservati per tutta la durata del servizio e successivamente archiviati per finalità storiche e statistiche\nLog di sistema: Conservati per un massimo di 12 mesi per finalità di sicurezza e debug' },
  { id: '18', type: 'heading', content: 'Comunicazione e Trasferimento dei Dati' },
  { id: '19', type: 'paragraph', content: 'I dati personali possono essere comunicati alle seguenti categorie di destinatari:' },
  { id: '20', type: 'list', content: 'Personale autorizzato: dipendenti e collaboratori del Titolare, debitamente istruiti\nFornitori di servizi IT: per hosting, manutenzione e assistenza tecnica della piattaforma\nAutorità competenti: quando richiesto per legge o per tutela di diritti in sede giudiziaria' },
  { id: '21', type: 'paragraph', content: 'Trasferimenti extra-UE: I dati sono ospitati su server ubicati nell\'Unione Europea. Qualsiasi eventuale trasferimento verso paesi terzi avverrà nel rispetto delle garanzie previste dal GDPR (decisioni di adeguatezza, clausole contrattuali standard).' },
  { id: '22', type: 'heading', content: 'Diritti dell\'Interessato' },
  { id: '23', type: 'paragraph', content: 'Ai sensi degli articoli 15-22 del GDPR, l\'interessato ha diritto di:' },
  { id: '24', type: 'list', content: 'Accesso: Ottenere conferma del trattamento e copia dei dati\nRettifica: Correggere dati inesatti o integrarli\nCancellazione: Richiedere la cancellazione dei dati (diritto all\'oblio)\nLimitazione: Limitare il trattamento in determinati casi\nPortabilità: Ricevere i dati in formato strutturato e leggibile\nOpposizione: Opporsi al trattamento per motivi legittimi' },
  { id: '25', type: 'paragraph', content: 'Per esercitare i propri diritti, contattare il Titolare all\'indirizzo email indicato nella sezione Contatti.' },
  { id: '26', type: 'heading', content: 'Cookie e Tecnologie di Tracciamento' },
  { id: '27', type: 'paragraph', content: 'La piattaforma e-CAA utilizza esclusivamente cookie tecnici essenziali per il funzionamento del servizio:' },
  { id: '28', type: 'list', content: 'Cookie di autenticazione: sb-access-token (token di accesso per l\'autenticazione della sessione), sb-refresh-token (token per il rinnovo automatico della sessione). Durata: scadono al logout o dopo il periodo di inattività configurato.\nPreferenze utente (localStorage): theme (preferenza del tema chiaro/scuro), sidebar-state (stato della sidebar aperta/chiusa). Durata: persistenti nel browser fino a cancellazione manuale.' },
  { id: '29', type: 'note', content: 'Nota: Non vengono utilizzati cookie analitici, di profilazione o di terze parti. I cookie tecnici sono essenziali e non richiedono consenso preventivo.' },
  { id: '30', type: 'heading', content: 'Misure di Sicurezza' },
  { id: '31', type: 'paragraph', content: 'Il Titolare adotta misure tecniche e organizzative adeguate per proteggere i dati personali:' },
  { id: '32', type: 'list', content: 'Crittografia: Comunicazioni HTTPS e password cifrate con algoritmi sicuri\nControllo accessi: Autenticazione obbligatoria e politiche di accesso basate sui ruoli\nBackup: Backup regolari dei dati con procedure di recovery testate\nMonitoraggio: Logging degli accessi e monitoraggio delle attività sospette' },
  { id: '33', type: 'heading', content: 'Modifiche alla Politica Privacy' },
  { id: '34', type: 'paragraph', content: 'Il Titolare si riserva il diritto di modificare la presente Politica Privacy in qualsiasi momento. Eventuali modifiche sostanziali saranno comunicate agli utenti attraverso:' },
  { id: '35', type: 'list', content: 'Notifica via email all\'indirizzo registrato\nAvviso all\'interno della piattaforma\nRichiesta di nuova accettazione al successivo accesso' },
  { id: '36', type: 'heading', content: 'Contatti' },
  { id: '37', type: 'paragraph', content: 'Titolare del Trattamento: Federlombarda Agricoltori\nEmail: rpd@confagricolturalombardia.it' },
  { id: '38', type: 'paragraph', content: 'Reclami all\'Autorità Garante: L\'interessato ha il diritto di proporre reclamo all\'Autorità Garante per la Protezione dei Dati Personali: www.garanteprivacy.it' }
];

const PrivacyPolicy = () => {
  const { token, user } = useAuth();
  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState([]);
  const [saving, setSaving] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [isMinorChange, setIsMinorChange] = useState(false);
  const [currentVersion, setCurrentVersion] = useState(1);
  const [manualVersion, setManualVersion] = useState('');
  const [lastUpdated, setLastUpdated] = useState(null);
  
  const isAdmin = user?.role === 'admin' || user?.role === 'super_admin';

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/legal/privacy-policy`);
      if (response.data && response.data.content && response.data.content.length > 0) {
        setContent(response.data.content);
        setCurrentVersion(response.data.version || 1);
        setLastUpdated(response.data.updated_at);
      } else {
        setContent(DEFAULT_PRIVACY_CONTENT);
      }
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setContent(DEFAULT_PRIVACY_CONTENT);
    } finally {
      setLoading(false);
    }
  };

  const startEditing = () => {
    setEditedContent(JSON.parse(JSON.stringify(content)));
    setIsEditing(true);
    setIsMinorChange(false);
    setManualVersion('');
  };

  const cancelEditing = () => {
    setEditedContent([]);
    setIsEditing(false);
    setIsMinorChange(false);
    setManualVersion('');
  };

  const saveContent = async () => {
    setSaving(true);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const payload = { 
        content: editedContent,
        is_minor_change: isMinorChange
      };
      
      // Add manual version if specified
      if (manualVersion && !isNaN(parseInt(manualVersion))) {
        payload.version = parseInt(manualVersion);
      }
      
      const response = await axios.put(`${API}/legal/privacy-policy`, payload, { headers });
      setContent(editedContent);
      setCurrentVersion(response.data.version || currentVersion);
      setIsEditing(false);
      setIsMinorChange(false);
      setManualVersion('');
      toast.success(response.data.message || 'Privacy Policy aggiornata con successo');
    } catch (error) {
      console.error('Error saving privacy policy:', error);
      toast.error('Errore nel salvataggio');
    } finally {
      setSaving(false);
    }
  };

  const updateBlock = (id, newContent) => {
    setEditedContent(prev => prev.map(block => 
      block.id === id ? { ...block, content: newContent } : block
    ));
  };

  const changeBlockType = (id, newType) => {
    setEditedContent(prev => prev.map(block => 
      block.id === id ? { ...block, type: newType } : block
    ));
  };

  const addBlock = (afterId, type = 'paragraph') => {
    const newBlock = {
      id: Date.now().toString(),
      type,
      content: type === 'heading' ? 'Nuovo Titolo' : type === 'list' ? 'Elemento 1\nElemento 2' : 'Nuovo paragrafo...'
    };
    
    const index = editedContent.findIndex(b => b.id === afterId);
    const newContent = [...editedContent];
    newContent.splice(index + 1, 0, newBlock);
    setEditedContent(newContent);
  };

  const deleteBlock = (id) => {
    if (editedContent.length <= 1) {
      toast.error('Deve esserci almeno un blocco');
      return;
    }
    setEditedContent(prev => prev.filter(block => block.id !== id));
  };

  const moveBlock = (id, direction) => {
    const index = editedContent.findIndex(b => b.id === id);
    if ((direction === 'up' && index === 0) || (direction === 'down' && index === editedContent.length - 1)) {
      return;
    }
    
    const newContent = [...editedContent];
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    [newContent[index], newContent[newIndex]] = [newContent[newIndex], newContent[index]];
    setEditedContent(newContent);
  };

  const exportToPdf = async () => {
    setExporting(true);
    try {
      const response = await axios.get(`${API}/legal/privacy-policy/export-pdf`, {
        responseType: 'blob'
      });
      
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Privacy_Policy_e-CAA-CONFAGRICOLTURA_${new Date().toISOString().split('T')[0]}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success('PDF esportato con successo');
    } catch (error) {
      console.error('Error exporting PDF:', error);
      toast.error('Errore nell\'esportazione del PDF');
    } finally {
      setExporting(false);
    }
  };

  const renderBlock = (block) => {
    switch (block.type) {
      case 'heading':
        return <h2 className="text-xl font-bold text-slate-800 mt-8 mb-3 first:mt-0">{block.content}</h2>;
      case 'paragraph':
        return <p className="text-slate-600 leading-relaxed mb-4 whitespace-pre-line">{block.content}</p>;
      case 'list':
        return (
          <ul className="list-disc list-outside ml-5 text-slate-600 mb-4 space-y-2">
            {block.content.split('\n').map((item, i) => (
              <li key={i} className="leading-relaxed">{item}</li>
            ))}
          </ul>
        );
      case 'note':
        return (
          <div className="bg-blue-50 border-l-4 border-blue-400 p-4 my-4">
            <p className="text-blue-800 text-sm">{block.content}</p>
          </div>
        );
      default:
        return <p className="text-slate-600">{block.content}</p>;
    }
  };

  const renderEditableBlock = (block) => {
    return (
      <div key={block.id} className="group relative border border-slate-200 rounded-lg p-4 mb-3 bg-white hover:border-[#3BA99C] transition-colors">
        <div className="absolute -top-3 left-3 flex items-center gap-1 bg-white px-2 z-10">
          <Select value={block.type} onValueChange={(value) => changeBlockType(block.id, value)}>
            <SelectTrigger className="h-7 text-xs border-slate-200 bg-white w-28">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="heading">Titolo</SelectItem>
              <SelectItem value="paragraph">Paragrafo</SelectItem>
              <SelectItem value="list">Lista</SelectItem>
              <SelectItem value="note">Nota</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <div className="absolute -top-3 right-3 flex items-center gap-1 bg-white px-1 opacity-0 group-hover:opacity-100 transition-opacity">
          <button onClick={() => moveBlock(block.id, 'up')} className="p-1 hover:bg-slate-100 rounded" title="Sposta su">
            <ArrowUp className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <button onClick={() => moveBlock(block.id, 'down')} className="p-1 hover:bg-slate-100 rounded" title="Sposta giù">
            <ArrowDown className="w-3.5 h-3.5 text-slate-500" />
          </button>
          <button onClick={() => deleteBlock(block.id)} className="p-1 hover:bg-red-100 rounded" title="Elimina blocco">
            <Trash2 className="w-3.5 h-3.5 text-red-500" />
          </button>
        </div>

        <textarea
          value={block.content}
          onChange={(e) => updateBlock(block.id, e.target.value)}
          className={`w-full border-0 focus:outline-none focus:ring-0 resize-y ${
            block.type === 'heading' ? 'text-lg font-bold min-h-[40px]' : 'text-sm min-h-[80px]'
          }`}
          placeholder={block.type === 'heading' ? 'Titolo sezione...' : block.type === 'list' ? 'Un elemento per riga...' : 'Contenuto...'}
        />

        <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity">
          <button
            onClick={() => addBlock(block.id)}
            className="flex items-center gap-1 px-2 py-1 bg-[#3BA99C] text-white text-xs rounded hover:bg-[#2D8A7F]"
          >
            <Plus className="w-3 h-3" />
            Aggiungi
          </button>
        </div>
      </div>
    );
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#3BA99C]"></div>
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-slate-900 flex items-center gap-3">
            <Shield className="w-8 h-8 text-[#3BA99C]" />
            Politica Privacy
          </h1>
          <div className="flex items-center gap-3 mt-1">
            <p className="text-slate-500">Informativa sul trattamento dei dati personali</p>
            <span className="px-2 py-0.5 bg-[#3BA99C]/10 text-[#3BA99C] text-xs font-medium rounded">
              v{currentVersion}
            </span>
            {lastUpdated && (
              <span className="text-xs text-slate-400 flex items-center gap-1">
                <Calendar className="w-3 h-3" />
                {new Date(lastUpdated).toLocaleDateString('it-IT')}
              </span>
            )}
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          {/* Export PDF Button - sempre visibile */}
          {!isEditing && (
            <button
              onClick={exportToPdf}
              disabled={exporting}
              className="flex items-center gap-2 px-4 py-2 bg-[#21358E] hover:bg-[#1a2a6c] text-white rounded-lg transition-colors disabled:opacity-50"
              data-testid="export-privacy-pdf-btn"
              title="Esporta in PDF"
            >
              <FileDown className="w-4 h-4" />
              {exporting ? 'Esportazione...' : 'Esporta PDF'}
            </button>
          )}
          
          {isAdmin && !isEditing && (
            <button
              onClick={startEditing}
              className="flex items-center gap-2 px-4 py-2 bg-[#3BA99C] hover:bg-[#2D8A7F] text-white rounded-lg transition-colors"
              data-testid="edit-privacy-btn"
            >
              <Edit2 className="w-4 h-4" />
              Modifica
            </button>
          )}
          
          {isAdmin && isEditing && (
            <div className="flex items-center gap-4 flex-wrap">
              {/* Campo versione manuale */}
              <div className="flex items-center gap-2 px-3 py-2 bg-slate-50 border border-slate-200 rounded-lg">
                <Hash className="w-4 h-4 text-slate-500" />
                <input
                  type="number"
                  min="1"
                  value={manualVersion}
                  onChange={(e) => setManualVersion(e.target.value)}
                  placeholder={`v${currentVersion}`}
                  className="w-16 text-sm border-0 bg-transparent focus:outline-none focus:ring-0"
                  title="Versione (lascia vuoto per auto-incremento)"
                />
                <span className="text-xs text-slate-500">versione</span>
              </div>
              
              {/* Checkbox modifica minore */}
              <label className="flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg cursor-pointer hover:bg-amber-100 transition-colors">
                <input
                  type="checkbox"
                  checked={isMinorChange}
                  onChange={(e) => {
                    setIsMinorChange(e.target.checked);
                    if (e.target.checked) setManualVersion('');
                  }}
                  disabled={manualVersion !== ''}
                  className="w-4 h-4 text-amber-600 rounded border-amber-300 focus:ring-amber-500"
                />
                <span className="text-sm text-amber-800">
                  Modifica minore <span className="text-xs text-amber-600">(stessa versione)</span>
                </span>
              </label>
              
              <button
                onClick={cancelEditing}
                className="flex items-center gap-2 px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg transition-colors"
              >
                <X className="w-4 h-4" />
                Annulla
              </button>
              <button
                onClick={saveContent}
                disabled={saving}
                className="flex items-center gap-2 px-4 py-2 bg-[#3BA99C] hover:bg-[#2D8A7F] text-white rounded-lg transition-colors disabled:opacity-50"
                data-testid="save-privacy-btn"
              >
                <Save className="w-4 h-4" />
                {saving ? 'Salvataggio...' : 'Salva'}
              </button>
            </div>
          )}
        </div>
      </div>

      <Card>
        <CardContent className="pt-6">
          {isEditing ? (
            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3 mb-4">
                <p className="text-sm text-blue-700">
                  <strong>Modalità modifica:</strong> Clicca sui blocchi per modificarli. Usa i controlli per cambiare tipo, riordinare o eliminare.
                </p>
              </div>
              {editedContent.map(block => renderEditableBlock(block))}
            </div>
          ) : (
            <div className="prose prose-slate max-w-none">
              {content.map(block => (
                <div key={block.id}>{renderBlock(block)}</div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default PrivacyPolicy;
